module.exports = __webpack_public_path__ + "public/Icons/loginArrowDark.svg?757b45ef";